import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ModalFooter from 'components/ModalFooter'
import ModalHeader from 'components/ModalHeader'
import ModalOutro from 'components/ModalOutro'
import { StyledModal } from './component.styles'
import AddGoals from './AddGoals'

const GOALS_ONLY_OUTRO_BUTTON_LABEL = 'Looks Great!'

const GoalsModal = ({
  additionalGoalCount,
  currentStep,
  flowLabel,
  goalsOnlyMode,
  handleCancel,
  handleChangeGoalCount,
  handleClose,
  handleCancelButtonClick,
  handleNextButtonClick,
  hideOutro,
  isComplete,
  modals,
  values,
  errors,
  preferences,
  touched,
  handleChange,
  hasApiError,
  goBack,
  interactedFields,
  isSubmitting,
  isValid,
}) => {
  const addGoalsData =
    modals?.find(modal => modal.internalTitle === 'k8 goals - add goal') || {}
  const finishData =
    modals?.find(modal => modal.internalTitle === 'k8 goals - finish') || {}
  const currentModal = currentStep === 0 ? addGoalsData : finishData
  const { cancelLabel, helpCopy, nextLabel } = currentModal
  const shouldSave = currentStep === 0

  return (
    !!modals && (
      <StyledModal
        dataTestId="goals-modal"
        isModalOpen
        modalClose={() => handleClose}
        wide
      >
        <ModalHeader
          flowLabel={goalsOnlyMode ? undefined : flowLabel}
          handleCancel={handleCancel}
          handleClose={handleClose}
          handleGoBack={goBack}
          showBackButton={currentStep !== 0}
        />
        {currentStep === 0 && (
          <Fragment key="add-goals">
            <AddGoals
              additionalGoalCount={additionalGoalCount}
              errors={errors}
              handleChange={handleChange}
              handleChangeGoalCount={handleChangeGoalCount}
              hasApiError={hasApiError}
              interactedFields={interactedFields}
              isValid={isValid}
              modalData={addGoalsData}
              preferences={preferences}
              touched={touched}
              values={values}
            />
            <ModalFooter
              cancelButtonText={cancelLabel}
              handleCancelButtonClick={() =>
                handleCancelButtonClick(shouldSave, false)
              }
              handleNextButtonClick={() =>
                handleNextButtonClick(shouldSave, true)
              }
              hasApiError={hasApiError}
              helpCopy={helpCopy}
              isSubmitting={isSubmitting}
              isValid={true}
              modalName="goals"
              nextButtonText={nextLabel}
              showCancelButton={currentStep === 0 && !isComplete}
            />
          </Fragment>
        )}
        {currentStep === 1 && !hideOutro && (
          <ModalOutro
            buttonOnClick={handleClose}
            modalData={
              goalsOnlyMode
                ? { ...finishData, nextLabel: GOALS_ONLY_OUTRO_BUTTON_LABEL }
                : finishData
            }
          />
        )}
      </StyledModal>
    )
  )
}

GoalsModal.propTypes = {
  additionalGoalCount: PropTypes.number,
  currentStep: PropTypes.number,
  errors: PropTypes.object,
  flowLabel: PropTypes.string,
  goBack: PropTypes.func,
  goalsOnlyMode: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleCancelButtonClick: PropTypes.func,
  handleChange: PropTypes.func,
  handleChangeGoalCount: PropTypes.func,
  handleClose: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  hasApiError: PropTypes.bool,
  hideOutro: PropTypes.bool,
  interactedFields: PropTypes.object,
  isComplete: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  modals: PropTypes.array,
  preferences: PropTypes.object,
  touched: PropTypes.object,
  values: PropTypes.object,
}

export default GoalsModal
